export function Productboard() {
  return (
    <div className="h-full w-full animate-fade-in">
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-foreground">Fenergo Roadmap</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          View and track product features and roadmap
        </p>
      </div>

      <div className="card h-[calc(100vh-12rem)] overflow-hidden rounded-lg border-border p-0">
        <iframe
          src="https://portal.productboard.com/wk9da8hyve6ssfsvu4jtyvo5"
          className="h-full w-full"
          title="Productboard Portal"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />
      </div>
    </div>
  );
}
